import Position from 'pages/path-finding-page/config/interfaces/Position';
import distanceBetweenTwoPosition from 'pages/path-finding-page/config/utils/distanceBetweenTwoPosition';
import isCurrentPositionOptimized from './isCurrentPositionOptimized';

export default function optimizeDistance(currentPosition: Position, prevPosition: Position) {
  if (!isCurrentPositionOptimized(currentPosition, prevPosition))
    currentPosition.value = prevPosition.value + distanceBetweenTwoPosition(currentPosition, prevPosition);
}
